import { withInstall } from '@xzx-design/utils'
import _ActionBar from './src/action-bar'
import _ActionBarButton from './src/action-bar-button'
import _ActionBarIcon from './src/action-bar-icon'

export const ActionBar = withInstall(_ActionBar)
export default ActionBar
export const ActionBarButton = withInstall(_ActionBarButton)
export const ActionBarIcon = withInstall(_ActionBarIcon)

export * from './src/action-bar'
export * from './src/action-bar-button'
export * from './src/action-bar-icon'
export * from './src/types'
